import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Pencil, Trash, Plus, X } from "@phosphor-icons/react";
import { toast } from "sonner";
import ImageUpload from "../../components/ImageUpload";

const empty = {
  title: { en: "", gr: "" }, client: "", year: new Date().getFullYear(), category: "event",
  image: "", description: { en: "", gr: "" },
};

const CATS = ["event", "club", "concert", "install"];

export default function AdminPortfolio() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/portfolio").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing.id) await api.put(`/admin/portfolio/${editing.id}`, editing);
      else await api.post("/admin/portfolio", editing);
      toast.success("Saved"); setEditing(null); load();
    } catch { toast.error("Save failed"); }
  };

  const del = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/admin/portfolio/${id}`); toast.success("Deleted"); load(); };

  return (
    <div data-testid="admin-portfolio">
      <div className="flex items-center justify-between mb-8">
        <h1 className="display-font text-3xl font-black uppercase">Portfolio</h1>
        <button onClick={() => setEditing({ ...empty })} className="btn-primary"><Plus size={18} weight="bold" /> New</button>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((p) => (
          <div key={p.id} className="card-dark overflow-hidden">
            {p.image && <div className="aspect-video"><img src={p.image} alt="" className="w-full h-full object-cover" /></div>}
            <div className="p-4">
              <div className="mono-font text-[10px] uppercase tracking-widest text-[#ccff00]">{p.client} · {p.year}</div>
              <div className="display-font font-bold mt-1">{p.title.en}</div>
              <div className="text-xs text-gray-500 mt-1">{p.category}</div>
              <div className="flex justify-end gap-2 mt-3">
                <button onClick={() => setEditing({ ...p })} className="p-2 hover:text-[#ccff00]"><Pencil size={16} /></button>
                <button onClick={() => del(p.id)} className="p-2 hover:text-[#ff003c]"><Trash size={16} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <form onSubmit={save} className="bg-[#0a0a0c] border border-[#2a2a35] max-w-2xl w-full max-h-[90vh] overflow-auto p-6">
            <div className="flex justify-between items-center mb-5">
              <h2 className="display-font text-2xl font-bold">{editing.id ? "Edit" : "New"} project</h2>
              <button type="button" onClick={() => setEditing(null)}><X size={20} /></button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <input required placeholder="Title (EN)" className="input-dark" value={editing.title.en} onChange={(e) => setEditing({ ...editing, title: { ...editing.title, en: e.target.value } })} />
              <input placeholder="Title (GR)" className="input-dark" value={editing.title.gr} onChange={(e) => setEditing({ ...editing, title: { ...editing.title, gr: e.target.value } })} />
              <input placeholder="Client" className="input-dark" value={editing.client} onChange={(e) => setEditing({ ...editing, client: e.target.value })} />
              <input type="number" placeholder="Year" className="input-dark" value={editing.year} onChange={(e) => setEditing({ ...editing, year: parseInt(e.target.value || 0) })} />
              <select className="input-dark" value={editing.category} onChange={(e) => setEditing({ ...editing, category: e.target.value })}>
                {CATS.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
              <div className="sm:col-span-2">
                <ImageUpload value={editing.image} onChange={(url) => setEditing({ ...editing, image: url })} label="Cover image" />
              </div>
              <textarea placeholder="Description (EN)" className="input-dark sm:col-span-2 min-h-[100px]" value={editing.description.en} onChange={(e) => setEditing({ ...editing, description: { ...editing.description, en: e.target.value } })} />
              <textarea placeholder="Description (GR)" className="input-dark sm:col-span-2 min-h-[100px]" value={editing.description.gr} onChange={(e) => setEditing({ ...editing, description: { ...editing.description, gr: e.target.value } })} />
            </div>
            <div className="mt-6 flex gap-3 justify-end">
              <button type="button" className="btn-outline" onClick={() => setEditing(null)}>Cancel</button>
              <button type="submit" className="btn-primary">Save</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
